import Constants from 'Constants'
import { EventBus } from 'EventBus'
import Common from '@/assets/js/common.js'

// Licences de l'espace client (celle du domaine, pas celle du user connecté) dont le règlement des factures se fait sur une page de paiement externe
const EXTERNAL_PAYMENT_URLS = {
    '1585-5F49-FF42-8E27-C776': 'https://www.monetico-online-pro.com/haras-de-semilly/paiement' // Haras de Semilly
}

const InvoiceMixin = {
    methods: {
        /**
         * URL de la page de paiement externe de la licence, null si elle passe par le paiement en ligne Groomy.
         * @returns {String|null}
         */
        getExternalPaymentUrl() {
            return EXTERNAL_PAYMENT_URLS[this.getConfig('ca_licence_key')] || null
        },

        getAddressedInvoicesToPay: async function() {
            const url = Constants.INVOICES_ADRESSED_TOPAY + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("InvoiceMixin::getAddressedInvoicesToPay", url)
			.catch(error => {
				console.error("InvoiceMixin::getAddressedInvoicesToPay => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },

        getAddressedInvoicesSold: async function() {
            const url = Constants.INVOICES_ADRESSED_PAID + "?licence_key="+Constants.USER_LICENCE_KEY
            
			const result = await this.$request.request_get_api("InvoiceMixin::getAddressedInvoicesSold", url)
			.catch(error => {
				console.error("InvoiceMixin::getAddressedInvoicesSold => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },

        getAddressedPayments: async function() {
            const url = Constants.PAIEMENTS_ADRESSED + "?licence_key="+Constants.USER_LICENCE_KEY
            
			const result = await this.$request.request_get_api("InvoiceMixin::getAddressedPayments", url)
			.catch(error => {
				console.error("InvoiceMixin::getAddressedPayments => ERROR", error)
				return null
			})

			return result ? result.retour : null
        },

        getAddressedPdfInvoice: async function(invoices) {
            invoices.forEach(invoice => {
                const url = this.constructRoute(Constants.INVOICES_PDF_ADDRESSED, {
                    invoice_id: invoice.invoice_id
                }) + "?licence_key="+Constants.USER_LICENCE_KEY

				this.$request.request_get_api("InvoiceMixin::pdfInvoice", url)
                    .then(res => {
                        const filename = invoice.invoice_num || invoice.invoice_date
				        Common.base64ToPdf(res, `${filename}.pdf`)
                        EventBus.$emit("TableAction::stopSpin")
                    })
                    .catch(error => {
                        console.error("InvoiceMixin::getAddressedPdfInvoice => ERROR", error)
                        return null
                    })
            })
		},


		// DEVIS
		getAllQuotation: async function() {
            const url = Constants.QUOTATIONS_ADRESSED + "?licence_key="+Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("InvoiceMixin::getAllQuotation", url)
			.catch(error => {
				console.error("InvoiceMixin::getAllQuotation => ERROR", error)
				return null
			})

			return result ? result.retour : null
		},

		/**
		 * Récupère le PDF d'un devis adressé au client connecté.
		 * @param {Number} quotation_id Identifiant du devis
		 * @param {String} quotation_num Numéro du devis, utilisé pour nommer le fichier téléchargé
		 * @param {Boolean} [base64=false] true pour retourner le contenu encodé, false pour déclencher le téléchargement
		 * @returns {Promise<String|null>} Le PDF en base64 si demandé, null en cas d'échec
		 */
		getQuotationPdf: async function(quotation_id, quotation_num, base64 = false) {
			const url = this.constructRoute(Constants.QUOTATIONS_PDF_ADDRESSED, {quotation_id}) + "?licence_key="+Constants.USER_LICENCE_KEY
			const result = await this.$request.request_get_api("QuotationMixins::getQuotationPdf", url)
			.catch(error => {
				console.error("QuotationMixins::getQuotationPdf => ERROR", error)
				return null
			})

			if(result) {
				if(base64) {
					return result
				}
				Common.base64ToPdf(result, quotation_num + ".pdf")
			}
			return null
		},

		loadInvoiceContract: async function(contract_id) {
			const url = `${this.constructRoute(Constants.CONTRACT_INVOICES_URL, {contract_id})}?licence_key=${Constants.USER_LICENCE_KEY}`
			const result = await this.$request.request_get_api("InvoiceMixin::loadInvoiceContract", url)

			if(result) return result.retour
			return null
		},
    }
}

export default InvoiceMixin